import React, { useState } from 'react';
import { joinThinkSeed } from 'modules/think-seeds/actions';
import tableImageColors from 'assets/images/think/tableImageColors.svg';
import {
  InvitationWrapper, UserInfo, LowerInfo, ButtonIgnore, ButtonJoin,
} from './styles';

const ACTION_ACCEPT_INVITATION = 'accept_invitation';
const ACTION_REJECT_INVITATION = 'reject_invitation';

function InvitationCard(props) {
  const {
    invitation, id, thinkSeedId, literals,
    rejectInvitation, acceptInvitation, getChats, joinToTable,
  } = props;

  const [action, setAction] = useState(null);
  const [loading, setLoading] = useState(false);

  const setIsNoLoading = () => {
    setLoading(false);
  };

  const handleOnConfirm = () => {
    if (!loading) {
      setAction(ACTION_ACCEPT_INVITATION);
      setLoading(true);
      joinThinkSeed(thinkSeedId).then(() => {
        getChats();
        acceptInvitation(invitation, thinkSeedId, setIsNoLoading);
        joinToTable(id);
      });
    }
  };

  const handleOnReject = () => {
    if (!loading) {
      setAction(ACTION_REJECT_INVITATION);
      setLoading(true);
      rejectInvitation(id, setIsNoLoading);
    }
  };

  return (
    <InvitationWrapper className='invitation_card'>
      <UserInfo>
        <div className='image'>
          <img src={props.avatar} alt='' />
        </div>
        <div className='info'>
          <div className='name'>
            {props.name}
          </div>
          <div className='text'>
            {literals.invitedYou}
          </div>
        </div>
      </UserInfo>
      <LowerInfo>
        <div className='cont'>
          <img src={tableImageColors} alt='' />
          <div className='text'>{props.table}</div>
        </div>
        <div className='buttons'>
          <ButtonIgnore onClick={handleOnReject}>
            {loading && action === ACTION_REJECT_INVITATION ? (
              <i className='fas fa-spinner fa-spin' />
            ) : null}
            {literals.ignore}
          </ButtonIgnore>
          <ButtonJoin onClick={handleOnConfirm}>
            {loading && action === ACTION_ACCEPT_INVITATION ? (
              <i className='fas fa-spinner fa-spin' />
            ) : null}
            {literals.join}
          </ButtonJoin>
        </div>

      </LowerInfo>
    </InvitationWrapper>
  );
}

export default InvitationCard;



// WEBPACK FOOTER //
// ./src/components/Cards/InvitationCard/components/index.jsx